import React from 'react'
import styled, { css } from 'styled-components'

import uniqid from 'uniqid'

export const Container = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-family: var(--primary-font);
  font-weight: 600;
  ${props => !props.active && (`
    pointer-events: none;
    opacity: 0.3;
  `)}

  label {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    padding-left: 2.6rem;
    font-size: 14px;
    font-weight: 400;

    &::before,
    &::after {
      content: '';
      display: block;
      border: 2px solid var(--gray-5);
      border-radius: 50%;
      position: absolute;
      left: 0px;
      top: ${props => (props.top ? props.top : '50%')};
      transform: translateY(-50%);
    }

    &::before {
      height: 20px;
      width: 20px;
    }

    &::after {
      opacity: 0;
      height: 1rem;
      width: 1rem;
      left: 5px;
      background-color: var(--cobasi-blue-light-9);
      transition: all ease .2s;
    }
  }

  input:checked ~ label::after,  input:checked ~ label::before {
    opacity: 1;
    border: 2px solid var(--cobasi-blue-light-9);
  }

  @media screen and (max-width: 500px) {
    flex-basis: 100%;
 }

  ${({ chipStyle }) => chipStyle && css`
    align-items: center;
    width: fit-content;
    flex-basis: initial !important;
    padding: 0;
    height: 32px;

    label {
      border: 1px solid #777777;
      padding: 8px 12px;
      border-radius: 40px;
      height: 100%;
      align-items: center;
      display: flex;
      flex-direction: row;

      &::before,
      &::after {
        display: none;
      }
    }

    input:checked ~ label,  input:checked ~ label {
      border-color: var(--cobasi-blue-light-8);
      background-color: var(--pet-anjo-lighter-blue);
      color: var(--cobasi-blue-light-8);
      border: 2px solid;
    }
  `}
`

const RadioInput = styled.input`
  display: none;
`

const Label = styled.label`
  font-size: 1.3rem;
  font-weight: 100;
  width: 100%;
  color: var(--gray-2);
`

class Radio extends React.Component {
  state = {
    selected: this.props.selected
  }

  handleChange = (event) => {
    this.setState({ selected: !this.state.selected })
    this.props.onChange && this.props.onChange(event.target.value)
  }

  render () {
    const { name, value, label, top, checked, id, dataTest, size, active = true, icon, chipStyle = false } = this.props
    const componentId = uniqid()

    return (
      <Container data-test='container-customradio' top={top} size={size} active={active} chipStyle={chipStyle}>
        <RadioInput
          type='radio'
          id={id || componentId}
          name={name}
          value={value}
          checked={!!checked}
          onChange={this.handleChange}
          onClick={(e) => { e.stopPropagation() }}
          data-test={dataTest}
        />

        <Label
          htmlFor={id || componentId}
        >
          {icon}
          {label}
        </Label>
      </Container>
    )
  }
}

export default Radio
